import e from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const i = {
  display: "block"
}, f = ({ size: a = 16, useVw: n, useRem: o, color: c, withColor: l, removeClassName: t, disableSSR: m, style: d, ...p }) => {
  const g = d ? { ...i, ...d } : i;
  return /* @__PURE__ */ e.createElement(x, { disableSSR: m }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "24px-wodegongdan", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: n ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (o ? "rem" : "px"), height: n ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (o ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: g, fill: "none", ...p }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: t ? "" : "24px-æçå·¥å"
    },
    /* @__PURE__ */ e.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: l ? r(c, 0, "#262933") : "#262933",
        datafollowfill: l ? r(c, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M7.005 8.025a.8.8 0 0 1 .8-.8h7.286a.8.8 0 1 1 0 1.6H7.805a.8.8 0 0 1-.8-.8Zm.8 3.571a.8.8 0 0 0 0 1.6h4.372a.8.8 0 1 0 0-1.6H7.805Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M3.363 5.11a2.986 2.986 0 0 1 2.985-2.985h11.304a2.986 2.986 0 0 1 2.985 2.986v13.778a2.986 2.986 0 0 1-2.985 2.986H6.348a2.986 2.986 0 0 1-2.985-2.986V5.111Zm2.985-1.385c-.765 0-1.385.62-1.385 1.386v13.778c0 .766.62 1.386 1.385 1.386h11.304c.765 0 1.386-.62 1.386-1.386V5.111c0-.766-.62-1.386-1.386-1.386H6.348Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, s = f;
export {
  s as default
};
